import React, { memo } from "react";
import { Button, Modal } from "../../../components/ui";

const LogoutModal = ({ show, onHide, onConfirm }) => (
  <Modal
    show={show}
    onHide={onHide}
    title="User Logout"
    size="md"
    footer={
      <div className="sb-sidebar__modal-footer">
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Yes, Logout
        </Button>
      </div>
    }
  >
    <p className="sb-sidebar__modal-body">
      Are you sure you want to logout?
    </p>
  </Modal>
);

export default memo(LogoutModal);
